﻿import { CompanyManagelistModel } from "./company-list";
export class CompanyListModel {
    data: Array<CompanyManagelistModel> = new Array<CompanyManagelistModel>();
    count: number = 0;
}